import {Injectable} from '@angular/core';
import {QueryParams} from '../../main/models/queryParams';
import {Params} from '@angular/router';

import queryString from 'query-string';
import {config} from '../../app.config';

@Injectable()
export class QueryParamsBuilder {

  public fromParams(params: Params, defaults: Partial<Params> = {}): QueryParams {

    return {
      filter: params.filter || defaults.filter || '',
      direction: params.direction || defaults.direction || 'asc',
      sortBy: params.sortBy || defaults.sortBy || 'id',
      pageIndex: params.pageIndex || defaults.pageIndex || 0,
      pageSize: params.pageSize || defaults.pageSize || config.smallScreenListItemsCount,
      category: params.category,
      archive: params.archive === 'true',
      pastClients: params.pastClients,
      reseller: params.reseller || defaults.reseller
    };
  }

  public fromQueryString(qs: string): QueryParams {
    if (!qs || !qs.includes('?')) {
      return null;
    }
    const de = decodeURI(qs.split('?')[1]);
    return queryString.parse(de);
  }

  public updateFromInputs(queryParams: QueryParams, filter: string, sort, paginator): QueryParams {
    return {
      ...queryParams,
      filter: filter ? filter : queryParams.filter,
      sortBy: sort.active ? sort.active : queryParams.sortBy,
      direction: sort.direction ? sort.direction : queryParams.direction,
      pageIndex: paginator.pageIndex,
      pageSize: paginator.pageSize ? paginator.pageSize : queryParams.pageSize
    };
  }
}
